// @flow
import * as React from 'react'
import SingleMascot from '../singlemascot/index.js'

import '@ta-interaktiv/semantic-ui/semantic/dist/components/icon.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/flag.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/label.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/grid.css'
import './style.scss'

type Props = {
  elementsPerRowDesktop: string,
  elementsPerRowMobile: string,
  mascotData: []
}

type State = {
  openElement: number
}

export class MascotGrid extends React.Component<Props, State> {
  state = {
    openElement: -1
  }

  render() {
    return (
      <div className='ui container mascot-container'>
        <div className='ui left aligned stackable grid all mascots'>
          {this.props.mascotData.length > 0 && (
            <div className='ui sixteen column row'>
              {this.props.mascotData.map((mascot, i) => {
                return (
                  <SingleMascot
                    key={`mascot-${i}`}
                    data={mascot}
                    id={i}
                    columnsDesktop={this.props.elementsPerRowDesktop}
                    columnsMobile={this.props.elementsPerRowMobile}
                  />
                )
              })}
            </div>
          )}
        </div>
      </div>
    )
  }
}

export default MascotGrid
